import parse from "html-react-parser";

type QuizTitleProps = {
  title: string;
  description?: string;
  className?: string;
};

const QuizTitle = ({ title, description, className = "" }: QuizTitleProps) => {
  return (
    <div className={className}>
      <h1 className="text-center text-[24px] font-bold leading-8 text-black">
        {title}
      </h1>

      {description && (
        <div className="pt-4 text-center text-[20px] font-normal leading-7 text-black">
          {parse(description)}
        </div>
      )}
    </div>
  );
};

export default QuizTitle;
